import React from 'react';
import { Popup, PopupText } from 'features/nekst-widgets';
import { NewLine, TextLink, usePopupManager } from 'ui-builder';

export function EventTaskConfigurationInfoMessage(props: {
  openSettingsFunc: () => void,
}) {
  return (
    <>
      In order to use Appointment Tasks, please link your Calendar to a Google Calendar from the Settings page.
      <NewLine />
      <NewLine />
      Go to
      {' '}
      <TextLink onClick={() => {
        props.openSettingsFunc();
      }}>
        Calendar Integration
      </TextLink>
      {' '}
      in Settings
    </>
  )
}

export function EventTaskConfigurationInfoPopup(
  props: {
    openSettingsFunc: () => void,
  }
) {
  const popupManager = usePopupManager();

  return (
    <Popup
      title="Appointment Tasks Setup"
      content={
        <PopupText>
          <EventTaskConfigurationInfoMessage
            openSettingsFunc={() => {
              props.openSettingsFunc();
              popupManager.closePopup();
            }}
          />
        </PopupText>
      }
    />
  );
}
